/*
 * @Author: your name
 * @Date: 2020-12-29 17:24:32
 * @LastEditTime: 2021-07-14 11:06:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /pub-app-new/src/commons/config.js
 */
/**
 * 项目配置文件
 */
// 是否启用mock数据
const isMock = false;
const hostName = window.location.hostname;
const isDev = /-dev|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(
  hostName
);
const isStg = /-stg/.test(hostName);
const isPre = /-pre/.test(hostName);
const isGra = /-gra/.test(hostName);
const isXL = /.xiaolachuxing/.test(hostName);
const envType = isDev || isStg ? '-stg' : isPre ? '-pre' : isGra ? '-gra' : '';

let dappwebUrl = `https://claim${envType}.huolala.cn/index.php`;
let dapiUrl = `//dapi${envType}.huolala.cn/index.php`;

const insuranceUrl = `https://insurance-web${envType}.huolala.cn`;

const xiaolaUserUrl = `https://user${envType}.xiaolachuxing.com`;

// 优惠券相关 网关接口url dev走webpack代理
const atomicUrl = isDev ? '/atomic-api' : `https://atomic${envType}.huolala.cn`;

// 多套测试环境部署
if (/-(stg|gra)\d/.test(hostName)) {
  dappwebUrl = `//claim.huolala${envType}.cn/index.php`;
  dapiUrl = `//dapi.huolala${envType}.cn/index.php`;
}

// 神策
let saurl = isXL ? 'https://uba.xiaolachuxing.com/sa?project=xluser' : 'https://uba.huolala.cn/sa?project=default';
if (isDev || isStg || isPre) {
  // DESC:如果是测试环境，小拉神策上报也用小b的
  // http://192.168.106.156:8106/sa/segmentation/?project=xluser
  // https://uba-dev.huolala.cn/sa?project=xluser
  saurl = isXL ? 'http://192.168.106.156:8106/sa/segmentation/?project=xluser' : 'https://uba-pre.huolala.cn/sa?project=default';
}

console.log('sa_url:::', saurl);

export default {
  xiaolaUserUrl,
  dappwebUrl,
  dapiUrl,
  saurl,
  atomicUrl,
  insuranceUrl,
  isMock,
  envType
};
